<ng-container *transloco="let t;">

  <div class="p-grid p-mt-2">
    <div class="p-col-8">
      <h3>{{ t('common.labels.candidates') }}</h3>
    </div>
    <div class="p-col-4 p-text-right" *ngIf="inEdit === true">
      <button *ngIf="canEditCandidates() === true" (click)="addCandidate()" pButton type="button" [label]="t('common.labels.add')" icon="pi pi-plus" class="p-button-secondary p-button-sm p-button-outlined" [disabled]="!canAddCandidate() ? true : null"></button>
    </div>
  </div>

  <p-table [value]="candidates">
    <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="gender">{{ t('common.labels.salutation') }}
              <p-sortIcon field="gender"></p-sortIcon>
          </th>
          <th pSortableColumn="lastname">{{ t('common.labels.lastname') }}
              <p-sortIcon field="lastname"></p-sortIcon>
          </th>
          <th pSortableColumn="firstname">{{ t('common.labels.firstname') }}
              <p-sortIcon field="firstname"></p-sortIcon>
          </th>
          <th pSortableColumn="mobile">{{ t('common.labels.mobile') }}
              <p-sortIcon field="mobile"></p-sortIcon>
          </th>
          <th pSortableColumn="email">{{ t('common.labels.email') }}
              <p-sortIcon field="email"></p-sortIcon>
          </th>
          <th>{{ t('common.labels.recommendation') }}</th>
          <th *ngIf="inEdit !== true"></th>
          <th *ngIf="inEdit === true && canEditCandidates() === true"></th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-candidate>
        <tr>
          <td>{{ t(candidate.getSalutation()) | dashWhenEmpty }}</td>
          <td>{{ candidate.lastname | dashWhenEmpty }}</td>
          <td>{{ candidate.firstname | dashWhenEmpty }}</td>
          <td>{{ candidate.mobile | dashWhenEmpty }}</td>
          <td>
            {{ candidate.email | dashWhenEmpty }}
            <span *ngIf="candidate.invited_at" class="p-text-small"><br/>{{ t('common.labels.invitation_sended_at') }} {{ candidate.invited_at | amLocal | amDateFormat: 'DD.MM.YYYY - HH:mm' }} {{ t('common.labels.oclock') }}</span>
          </td>
          <td><strong>{{ candidate.recommendation | dashWhenEmpty }}</strong></td>
          <td class="p-text-right" *ngIf="inEdit !== true"><button *ngIf="canResendEmail(candidate) === true" pButton type="button" (click)="onResendInvitation(candidate)" icon="pi pi-envelope" [pTooltip]="t('ac_persons.resend_invitation')" tooltipPosition="left" class="p-button-outlined"></button></td>
          <td *ngIf="inEdit === true && canEditCandidates() === true" class="p-text-right" style="width: 110px">
            <button pButton (click)="editCandidate(candidate)" type="button" icon="pi pi-pencil" class="p-button-outlined p-mr-2" [disabled]="(submitting === true) ? true : null"></button>
            <button pButton (click)="deleteCandidate(candidate)" type="button" icon="pi pi-trash" class="p-button-outlined danger-button" [disabled]="(submitting === true) ? true : null"></button>
          </td>
        </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td class="no-data" colspan="10">{{ t('common.labels.no_data') }}</td>
      </tr>
    </ng-template>
  </p-table>

  <p-dialog [header]="t('common.labels.add_candidate')" [(visible)]="dialogVisible" [style]="{width: '80vw'}" [draggable]="false" [modal]="true">
    <form (submit)="saveCandidate()">
      <div>
        <p class="p-text-right">
          <button type="button" pButton [label]="t('partials.employee_search.topline')" icon="pi pi-search" (click)="onOpenEmployeeSearch()" [disabled]="disabled" class="p-button-sm p-button-secondary p-button-outlined"></button>
        </p>

        <div class="p-grid">
          <div class="p-col-4">
            <app-form-control [cid]="'gender'" [control]="candidateForm.get('gender')" [type]="'select'" [options]="optionsSalutations" [label]="t('common.labels.gender')"></app-form-control>
          </div>
          <div class="p-col-4">
            <app-form-control [cid]="'firstname'" [control]="candidateForm.get('firstname')" [type]="'input'" [label]="t('common.labels.firstname')"></app-form-control>
          </div>
          <div class="p-col-4">
            <app-form-control [cid]="'lastname'" [control]="candidateForm.get('lastname')" [type]="'input'" [label]="t('common.labels.lastname')"></app-form-control>
          </div>
          <div class="p-col-4">
            <app-form-control [cid]="'email'" [control]="candidateForm.get('email')" [type]="'input'" [label]="t('common.labels.email')"></app-form-control>
          </div>
          <div class="p-col-4">
            <app-form-control [cid]="'phone'" [control]="candidateForm.get('phone')" [type]="'input'" [label]="t('common.labels.phone')"></app-form-control>
          </div>
          <div class="p-col-4">
            <app-form-control [cid]="'mobile'" [control]="candidateForm.get('mobile')" [type]="'input'" [label]="t('common.labels.mobile')"></app-form-control>
          </div>
        </div>

      </div>
      <p-footer>
        <div class="p-text-right">
          <button pButton (click)="cancelCandidate()" type="button" label="{{ t('common.labels.cancel') }}" class="p-button-outlined p-button-secondary p-mr-2"></button>
          <button pButton type="submit" label="{{ t('common.ok') }}" class="p-button-success"></button>
        </div>
      </p-footer>
    </form>
  </p-dialog>

  <app-employee-search #employeesearch (select)="onSelectEmployee($event)"></app-employee-search>

</ng-container>
